import { createRequest, getEndpoint } from "../requestCreator";

export const getSchedulerGroups = createRequest(getEndpoint("schedulers.sub.groups.sub.get"));
export const updateSchedulerGroups = createRequest(getEndpoint("schedulers.sub.groups.sub.update"));
export const replaceSchedulerGroups = createRequest(
  getEndpoint("schedulers.sub.groups.sub.replace"),
);
